import { Box, Grid } from '@mui/material';
import React from 'react';
import { formatDate } from '../../../app/utils';
import { useIntl } from 'react-intl';
import { useGetAssetConfigurationsQuery } from '../../../app/redux-fetch/apiAssets';
import { useGetCustomersQuery, useGetUserTypesQuery } from '../../../app/redux-fetch/apiQuery';
import { useGetCurrenciesByCustomerIdQuery } from '../../../app/redux-fetch/apiOrders';
import BoxWhiteContainer from '../../../components/Containers/BoxWhiteContainer';
import DefaultSpacingGrid from '../../../components/Containers/DefaultSpacingGrid';
import InfoDisplayItem from '../../../components/Typographies/InfoDisplayItem';
import { LabelItem } from '../../../components/Typographies/LabelItem';
import messages from './messages';
import { OrderDto } from './types';

interface AssetHireSummaryProps {
    data: OrderDto | null;
}

const AssetHireSummary: React.FC<AssetHireSummaryProps> = ({ data }) => {
    const isSmallScreen = false;
    const tenantId = data?.tenantId ?? 0;
    const customerId = data?.customerId ?? 0;

    const { formatMessage } = useIntl();

    const { data: customers = [] } = useGetCustomersQuery(tenantId)

    const { data: currencies = [] } = useGetCurrenciesByCustomerIdQuery({
        customerId, hideDisabled: true,
    })

    const { data: workforcesTypes = [] } = useGetUserTypesQuery({
        tenantId,
    })
    const { data: assetConfigurations = [], isSuccess: assetConfigurationLoaded } = useGetAssetConfigurationsQuery({ tenantId })

    const getAssetConfigurationName = (assetConfigurationId?: number) => {
        return assetConfigurations.find((ac) => ac.id === assetConfigurationId)?.name;
    }
    if (!data) return null;

    return (
        <Box>
            {data?.bookings?.map((booking, index) => (
                <>
                    <BoxWhiteContainer >
                        <DefaultSpacingGrid container>
                            <Grid item xs={12} md={3}>
                                <LabelItem>{formatMessage(messages.assetHire)} {`# ${index + 1}`}</LabelItem>
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <InfoDisplayItem
                                    label={formatMessage(messages.assetConfiguration)}
                                    value={getAssetConfigurationName(booking.assetConfigurationId) || 'N/A'}
                                    isSmallScreen={isSmallScreen}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <LabelItem>{formatMessage(messages.assetHirePickupDetails)}</LabelItem>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <InfoDisplayItem
                                    label={formatMessage(messages.location)}
                                    value={booking?.waypoints && booking?.waypoints[0].location?.name || 'N/A'}
                                    isSmallScreen={isSmallScreen}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoDisplayItem
                                    label={formatMessage(messages.dateAndTime)}
                                    value={booking?.waypoints && booking?.waypoints[0].scheduledDate ? formatDate(booking.waypoints[0].scheduledDate) : 'N/A'}
                                    isSmallScreen={isSmallScreen}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <LabelItem>{formatMessage(messages.assetHireReturnDetails)}</LabelItem>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <InfoDisplayItem
                                    label={formatMessage(messages.location)}
                                    value={booking?.waypoints && booking?.waypoints[1].location?.name || 'N/A'}
                                    isSmallScreen={isSmallScreen}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InfoDisplayItem
                                    label={formatMessage(messages.dateAndTime)}
                                    value={booking?.waypoints && booking?.waypoints[1].scheduledDate ? formatDate(booking.waypoints[1].scheduledDate) : 'N/A'}
                                    isSmallScreen={isSmallScreen}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <LabelItem>{formatMessage(messages.workforceDetails)}</LabelItem>
                            </Grid>
                            {booking.workforce && (
                                <>
                                    {booking.workforce.map((workforce, workforceIndex) => (
                                        <>
                                            {workforceIndex !== 0 && (
                                                <Grid item xs={0} md={3}></Grid>
                                            )}
                                            <Grid item xs={12} md={3}>
                                                <InfoDisplayItem
                                                    label={formatMessage(messages.workforceType)}
                                                    value={workforcesTypes.find((wt: any) => wt.id === workforce.workforceTypeId)?.name.toString() || 'N/A'}
                                                    isSmallScreen={isSmallScreen}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <InfoDisplayItem
                                                    label={formatMessage(messages.quantity)}
                                                    value={workforce.quantity?.toString() || 'N/A'}
                                                    isSmallScreen={isSmallScreen}
                                                />
                                            </Grid>
                                        </>
                                    ))}
                                </>
                            )}
                        </DefaultSpacingGrid>
                    </BoxWhiteContainer>
                </>
            ))}
        </Box>
    );
};

export default AssetHireSummary
